module.exports = __webpack_public_path__ + "static/media/0@3x.4124b6e3.png";